export const DONT_CLOSE_MENU_FLAG = 'dont-close-menu-list'
